module.exports = __webpack_public_path__ + "static/media/newlogo.f873404a.png";